// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"ce554592d5ef60743660","293":"6370dc2561ac331165f5","518":"9c423719e189bbf4b9a5","779":"83c329e2bccf982d0b4c"}[chunkId] + ".js";
};